import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { EApiReportReasonId } from "utils/offer";

type TInput = {
  offerId: number;
  reason: EApiReportReasonId;
  email: string;
  description: string;
};

type TOutput = void;

export default class ReportOfferApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;

  resolveUri({ offerId }: TInput): string {
    return `/fe-api/offer/report/${offerId}`;
  }

  mapRequestData({ email, reason, description }: TInput): any {
    return {
      email,
      type: reason,
      text: description,
    };
  }
}
